var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-y-transition"}},[(_vm.show)?_c('v-btn',{staticClass:"white--text refresh-button",staticStyle:{"text-transform":"none"},attrs:{"disabled":_vm.disabled,"small":"","round":"","color":"blue darken-2"},on:{"click":function () {this$1.$emit('click')}}},[_vm._v("Refresh Data")]):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e4b6641","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/heatmap/RefreshButton.vue
// module id = null
// module chunks = 